import { useAuthToken } from "./useAuthToken";

export const useConstructUrl = () => {
  const { token } = useAuthToken();

  return (url: string, params?: any) => {
    return token ? url + "?token=" + token : url;
  };
};
